/**
 * Twenty Mae — Wishlist (heart) button
 * Shared by collection tiles and the "You Might Also Like" reco slider.
 * localStorage-backed, no server round trip.
 */
(function () {
  'use strict';

  var WISH_KEY = 'twentyMaeSavedProducts';

  function getSaved() {
    try {
      return JSON.parse(localStorage.getItem(WISH_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setSaved(arr) {
    localStorage.setItem(WISH_KEY, JSON.stringify(arr));
  }

  function isSaved(id, saved) {
    saved = saved || getSaved();
    return saved.some(function (p) { return String(p.id) === String(id); });
  }

  function syncWishButtons() {
    var saved = getSaved();
    document.querySelectorAll('[data-tm-wish-btn]').forEach(function (btn) {
      var active = isSaved(btn.dataset.wishId, saved);
      btn.classList.toggle('tm-saved', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function initWishButtons() {
    document.querySelectorAll('[data-tm-wish-btn]').forEach(function (btn) {
      if (btn.dataset.wishBound) return;
      btn.dataset.wishBound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var id = btn.dataset.wishId;
        var saved = getSaved();
        var idx = saved.findIndex(function (p) { return String(p.id) === String(id); });

        if (idx > -1) {
          saved.splice(idx, 1);
        } else {
          saved.push({
            id: id,
            handle: btn.dataset.wishHandle,
            title: btn.dataset.wishTitle,
            url: btn.dataset.wishUrl,
            img: btn.dataset.wishImg,
            saved_at: Date.now()
          });
        }

        setSaved(saved);
        btn.classList.toggle('tm-saved', idx === -1);
        btn.setAttribute('aria-pressed', idx === -1 ? 'true' : 'false');
        document.dispatchEvent(new CustomEvent('tm:saved-update'));
      });
    });

    syncWishButtons();
  }

  document.addEventListener('tm:saved-update', syncWishButtons);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishButtons);
  } else {
    initWishButtons();
  }

  document.addEventListener('shopify:section:load', initWishButtons);
})();
